import { logError } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';

import { createFilterStatusMap } from '../../../../../entities/flights/itineraries/createFilterStatusMap';

import { mapAttributeIdLookup } from './commonMapAttributeIdLookup';
import { mapSonarV3PricingOptions } from './sonarV3PricingOptionsMapper';

import type { PersonalItemAssessmentOutcome } from './sonarV3PricingOptionFareMapper';
import type { SkyscannerSonarV3Response } from '@skyscanner-internal/sonar-web-http-client';
import type { UpgradesBookingPanel } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/flights/itinerariesBookingPanel';
import type { Maybe } from '@web-platform/shared-universal-types-utils/src/utils';

type SonarPricingOption = SkyscannerSonarV3Response.PricingOption;
type SonarPricingOptionIdsByAttribute = SkyscannerSonarV3Response.PricingOptionIdsByAttribute;

export const mapSonarV3Upgrades = (
  pricingOptions: Maybe<SonarPricingOption[]>,
  pricingOptionIdsByAttribute: Maybe<SonarPricingOptionIdsByAttribute[]>,
  personalItemOutcome: PersonalItemAssessmentOutcome = 'INCLUDED',
): UpgradesBookingPanel | undefined => {
  try {
    if (!pricingOptionIdsByAttribute?.length || !pricingOptions?.length) {
      return undefined;
    }

    const attributeIdLookup = mapAttributeIdLookup(pricingOptionIdsByAttribute);

    return {
      pricingOptions: mapSonarV3PricingOptions(pricingOptions, personalItemOutcome),
      attributeOptionIdLookup: attributeIdLookup,
      filterStatusMap: createFilterStatusMap(attributeIdLookup),
    };
  } catch (err) {
    logError({
      component: 'mapSonarV3Upgrades',
      message: 'Error mapping sonar upgrades',
      error: err,
      stack: err.stack,
      data: JSON.stringify({
        pricingOptions,
        pricingOptionIdsByAttribute,
      }),
    });
    return undefined;
  }
};
